import { render, staticRenderFns } from "./TheSourceRating.vue?vue&type=template&id=1306ae84&"
import script from "./TheSourceRating.vue?vue&type=script&lang=js&"
export * from "./TheSourceRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports